module.exports = __webpack_public_path__ + "static/media/lock.424c988e.png";